import React, {useEffect, useState} from "react";
import "./IvecoForm.scss";
import PrivacyForm from "../../ivecodotcom/components/PrivacyForm";
import withErrorCatch from "../../helper/withErrorCatch";
import {useStore} from "react-redux";

const IvecoForm = (props: any) => {
  try {
    const [domReady, setDomReady] = useState(false);
    useEffect(() => {
      if (typeof document !== "undefined") setDomReady(true);
    }, [document]);
    return (
      <div className={"IvecoForm"}>
        {domReady ? <PrivacyForm {...props} /> : <></>}
      </div>
    );
  } catch (error) {
    console.error(error);

    return <>{(error as Error)?.stack}</>;
  }
};

export default withErrorCatch(IvecoForm);
